module.exports = __webpack_public_path__ + "img/main-q-wlogin3.67059624.png";